import { FC } from "react";

import { Box, Typography } from "@mui/material";

interface Props {
  title: string;
  description?: string;
}

const ComingSoonPage: FC<Props> = ({ title, description }) => (
  <Box
    sx={{
      p: 3,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      color: "text.secondary",
    }}
  >
    <Typography variant="h4" sx={{ mb: 1 }}>
      {title}
    </Typography>
    <Typography variant="body1">{description ?? "Coming soon"}</Typography>
  </Box>
);

export default ComingSoonPage;
